// extracted by mini-css-extract-plugin
export default {"container":"ImagePreview_container__88RvM","image":"ImagePreview_image__wSk7t","remove":"ImagePreview_remove__DU9hm","spin":"ImagePreview_spin__8vsx6"};